import React, {useContext, useEffect, useState} from "react";
import {Link, Route, Routes} from "react-router-dom";
import Alerts from "./Alerts";
import LastViewed from "./LastViewed";
import LastCreated from "./LastCreated";
import StateClient from "../../../load/StateClient";
import LastRequests from "./LastRequests";
import LastNews from "./LastNews";
import IdeasIcon from "../../../icons/IdeasIcon";
import FormSheet from "../../../overbox/sheet/FormSheet";
import LoaderCircle from "../../../tools/loader/LoaderCircle";
import StateDevelopmentRequest from "../../../load/StateDevelopmentRequest";
import AuthController from "../../../../stories/_auth/Auth/AuthController";
import AppContext from "../../../../context/AppContext";
import "../../../../css/page/Dashboard.css";

const Dashboard = () => {
	const { getDatasPopup, statePopup, subStatePopup, setEvent } = useContext(AppContext);
	const [ innerObjectType, setInnerObjectType ] = useState(null);
	const [ innerObjectSubType, setInnerObjectSubType ] = useState(null);
	const [ innerDatas , setInnerDatas ] = useState(null);
	const isEnableDR = ['production'].includes(process.env.REACT_APP_ENV);
    const item = "dashboard";
    const itemClass = "dashboard";
	const titleWindow = "Tableau de bord";

	const checkState = type => {
		switch (type) {
			case "informations":
			case "journal":
			case "environnement":
			case "contrats":
				if (statePopup !== "loading" && (getDatasPopup === null || getDatasPopup.store === undefined))
					return "loading";
				else
					return statePopup;
			default:
				return null;
		}
	}
	const stateInnerPopup = () => {
		return innerObjectType !== null
	}
	const stateInnerForm = () => {
		switch (innerObjectType) {
			case "createDevelopmentRequest":
				if (innerDatas !== null)
					return true;

				break;
			default: break;
		}

		return false;
	}
	const titleFormSheet = () => {
		switch (innerObjectType) {
			default:
				return "";
		}
	}
	const closeInnerForm = () => {
		setInnerObjectType(null);
		setInnerDatas(null);
	}
	const returnInnerForm = () => {
		closeInnerForm();
	}

    useEffect(() => {
        document.title = titleWindow;
    }, []);

    return (
		<>
			<div className={"overlay" + (stateInnerPopup() ? " appear" : "")}>
				<div className={"wrapPopup"}>
					<div className={"popup " + (stateInnerForm() ? "new" : "loading")}>
						{
							stateInnerForm()
								? <FormSheet
									objectType={ innerObjectType }
									objectSubType={ innerObjectSubType }
									datas={ innerDatas }
									parentDatas={ {} }
									title={ titleFormSheet() }
									callbackClose={ closeInnerForm }
									callbackSuccess={ returnInnerForm } />
								: <div className={"containerLoading"}>
									<LoaderCircle display="loader inPopup" hide="" strokeWidth="10" stroke="#00000070" />
								</div>
						}
					</div>
				</div>
			</div>
			<div className="dashboard">
				<Alerts />
				<div className={"block actions"}>
					{
						isEnableDR
						&& <Link to={ "developmentrequests/new" }>
							<div className={"action"}><IdeasIcon /><p>Faire une demande d'évolution</p></div>
						</Link>
					}
				</div>
				<div className={"block master"}>
					<LastViewed />
					<LastCreated />
				</div>
				<div className={"block master"}>
					{
						AuthController.fromSkyTeam()
						&& <LastRequests />
					}
					<LastNews />
				</div>
				{/* Fragment */}
				{/* Version states */}
				{/* (internal) Contracts */}
				{/* (internal) roadmap */}
				<Routes>
					<Route index element={<StateClient state={"hidden"} />} />
					<Route exact path="clients/:id/informations" element={<StateClient state={checkState("informations")} subState={"sheet"} loadingText={"Ouverture de la fiche client..."} loadingIcon={true} />} />
					<Route exact path="clients/:id/journal" element={<StateClient state={checkState("journal")} subState={"sheet"} loadingText={"Ouverture de la fiche client..."} loadingIcon={true} />} />
					<Route exact path="clients/:id/environnement" element={<StateClient state={checkState("environnement")} subState={"sheet"} loadingText={"Ouverture de la fiche client..."} loadingIcon={true} />} />
					<Route exact path="clients/:id/contrats" element={<StateClient state={checkState("contrats")} subState={"sheet"} loadingText={"Ouverture de la fiche client..."} loadingIcon={true} />} />
					<Route exact path="developmentrequests/new" element={<StateDevelopmentRequest state={"loading"} subState={"new"} loadingText={"Chargement..."} loadingIcon={true} />} />
				</Routes>
			</div>
		</>
    )
}

export default Dashboard;
